import React from "react";
import { authRoles } from "../../auth/authRoles";

const manufactureRoute = [
  {
    path: "/manufacture/products",
    component: React.lazy(() => import("./CStoreProducts")),
    auth: authRoles.user,
  },
  {
    path: "/manufacture/applications",
    component: React.lazy(() => import("./CApplication")),
    auth: authRoles.user,
  },
  {
    path: "/manufacture/specifications",
    component: React.lazy(() => import("./CSpecification")),
    auth: authRoles.user,
  },
  {
    path: "/manufacture/items",
    component: React.lazy(() => import("./CManufacture")),
    auth: authRoles.user,
  },
];

export default manufactureRoute;